import React, { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { IonInput, IonPopover } from '@ionic/react'
import { restaurantConfig } from '@mobx/mall'
import { checkoutMobx, memberMobx } from '@mobxStore'
import { confirmLayer, useHistoryNew } from '@utils'
import { validMobileOrMail } from '@dt/fe-utils'
import { UsernameInput } from '@cps'
import { LoginGuide } from '../../component'
import './index.scss'

export interface ICheckoutContactProps {
  hide?: boolean;
}

const CheckoutContact: React.FC<ICheckoutContactProps> = ({ hide }) => {
  const {
    contactInfo,
    contactError,
    isSaveOrderInfo,
    setContactInfo,
    resetContactError,
    setIsSaveOrderInfo,
  } = checkoutMobx
  const [popoverState, setShowPopover] = useState({
    showPopover: '',
    event: undefined,
  })

  const history = useHistoryNew()

  useEffect(() => {
    if (memberMobx.isLogin) {
      setTimeout(() => {
        setContactInfo({
          contactName: contactInfo.contactName || memberMobx.memberInfo.nickName,
          contactMobile: contactInfo.contactMobile || memberMobx.memberInfo.mobile,
          countryCode: (!contactInfo.contactMobile || !contactInfo.countryCode) && memberMobx.memberInfo.countryCode ? String(memberMobx.memberInfo.countryCode) : contactInfo.countryCode
        })
      })
    }
  }, [memberMobx.memberInfo])

  useEffect(() => {
    if (!contactInfo.contactMobile) {
      setContactInfo({
        ...contactInfo,
        countryCode: String(window.bo === 'cn' ? 86 : window.bo === 'us' ? 1 : 49)
      })
    }
  }, [])

  const [expand, setExpand] = useState(false)
  const [hasBenefits, setHasBenefits] = useState(false)

  const handleChangeIsSaveOrderInfo = () => {
    if (isSaveOrderInfo && memberMobx.isLogin) {
      confirmLayer({
        title: i18n.t('common.attention'),
        confirmText: i18n.t('mkt.common.confirm'),
        children: (
          <>
            <p>{i18n.t('checkout.clearOrderAfterCancel')}</p>
            {i18n.t('checkout.carefulOption')}
          </>
        ),
        cancelText: i18n.t('mkt.common.cancel'),
        className: 'cart-confirm-modal',
      })
        .then(() => {
          if (memberMobx.isLogin) {
            memberMobx.logout()
          }
          setIsSaveOrderInfo(!isSaveOrderInfo)
        })
        .catch(() => {})
      return
    }
    setIsSaveOrderInfo(!isSaveOrderInfo)
  }

  const _tipRender = () => (
    <div className='checkout-contact-tip start'>
      <button type='button' onClick={handleChangeIsSaveOrderInfo}>
        <i
          className={`iconfont icon-checkmark--outline${
            isSaveOrderInfo ? ' checked' : ''
          }`}
        >
        </i>
        <span className='ml'>{i18n.t('checkout.saveOrderInfo')}</span>
      </button>
      <a
        className='ml link'
        onClick={(e: any) => {
          e.persist()
          setShowPopover({ showPopover: 'tip', event: e })
        }}
      >
        {i18n.t('cart.details')}
      </a>
      <IonPopover
        cssClass='cart-tips-popover'
        event={popoverState.event}
        isOpen={popoverState.showPopover === 'tip'}
        onDidDismiss={() =>
          setShowPopover({ showPopover: '', event: undefined })}
      >
        <p>{i18n.t('checkout.saveOrderTips')}</p>
        <span
          onClick={(e: any) => {
            e.persist()
            setShowPopover({ showPopover: '', event: undefined })
          }}
        >
          {i18n.t('newCart.know')}
        </span>
      </IonPopover>
    </div>
  )

  const notFill = useMemo(() => {
    if (restaurantConfig.codeType === 'table' || expand) {
      return false
    }
    let result = false
    // 品牌码手机号和昵称都必须填（中国无需填写昵称）
    if (restaurantConfig.codeType === 'brand') {
      result = (window.bo !== 'cn' && !contactInfo.contactName) || !validMobileOrMail('mobile', contactInfo.contactMobile, contactInfo.countryCode)
    }
    // 门店码手机号和昵称都非必须填
    if (restaurantConfig.codeType === 'store') {
      result = (window.bo !== 'cn' && !contactInfo.contactName) || (contactInfo.contactMobile && !validMobileOrMail('mobile', contactInfo.contactMobile, contactInfo.countryCode))
    }
    setExpand(result)
    return result
  }, [contactInfo])

  useEffect(() => {
    if (!(expand || notFill)) {
      !memberMobx.isLogin && checkHasBenefits()
    }
  }, [expand, notFill])

  if (hide) {
    return null
  }

  const checkHasBenefits = () => {
    contactInfo.countryCode && contactInfo.contactMobile && memberMobx.checkHasBenefits({
      mobile: contactInfo.contactMobile,
      countryCode: parseInt(contactInfo.countryCode)
    }).then(res => {
      setHasBenefits(!!res?.isMember && !!res?.hasBenefits)
    }).catch(e => {
      setHasBenefits(false)
    })
  }

  const _unExpandRender = () => (
    <div className='checkout-contact-bar' onClick={() => setExpand(true)}>
      <div className='checkout-contact-bar-title'>
        {window.bo !== 'cn' && contactInfo.contactName && <span>{contactInfo.contactName}</span>}
        {contactInfo.contactMobile && <span>{contactInfo.contactMobile}</span>}
        <i className='iconfont icon-edit1'></i>
      </div>
      {/* {
        !contactInfo.contactName && !contactInfo.contactMobile ? (
          <small style={{ color: '#7A7A7A' }}>
            {i18n.t('checkout.whatContactInfo')}
          </small>
        ) : null
      } */}
      <small style={{ color: '#7A7A7A' }}>
        {i18n.t('checkout.whatContactInfo')}
      </small>
      {/* <div className='checkout-contact-edit' onClick={() => setExpand(true)}>
        <i className='iconfont icon-edit1'></i>
      </div> */}
    </div>
  )

  const hasBenefitsContentReander = () => {
    return (
      <div className='mall-login-guide-wrapper benefits' onClick={() => history.push({ pathname: '/login', state: { countryCode: contactInfo.countryCode, contactMobile: contactInfo.contactMobile } })}>
        <div className='login-guide-info'>{i18n.t('checkout.hasBenefits')}</div>
        <i className='iconfont icon-arrows-right'></i>
      </div>
    )
  }

  const _expandRender = () => (
    <div className='checkout-contact-container'>
      <header>
        <strong>{i18n.t('checkout.contactInfo')}</strong>
      </header>
      <small style={{ color: '#7A7A7A' }}>
        {i18n.t('checkout.whatContactInfo')}
      </small>
      <div className='checkout-contact-form'>
        {window.bo !== 'cn' && (
          <>
            <div
              className={`checkout-contact-form-item${
                contactError.nameError ? ' error-form-item' : ''
              }`}
            >
              <span className='checkout-contact-form-item-icon'>
                <i className='iconfont icon-my-circle'></i>
              </span>
              <IonInput
                value={contactInfo.contactName}
                placeholder={i18n.t('mkt.common.tipNickName')}
                onIonChange={({ detail: { value } }) => {
                  setContactInfo({
                    ...contactInfo,
                    contactName: value,
                  })
                  resetContactError()
                }}
              />
            </div>
            <div
              className='checkout-contact-error show'
              style={{ display: contactError.nameError ? 'block' : 'none' }}
            >
              <span>{i18n.t('checkout.howICallYou')}</span>
            </div>
          </>
        )}
        <div
          className={`checkout-contact-form-item${
            contactError.mobileError ? ' error-form-item' : ''
          }`}
        >
          <UsernameInput
            value={{
              pass: contactInfo.contactMobile,
              countryCode: parseInt(contactInfo.countryCode),
            }}
            inputType='mobile'
            placeholder={i18n.t('mkt.common.tipMobile')}
            onChange={(data) => {
              setContactInfo({
                ...contactInfo,
                contactMobile: data.pass,
                countryCode: String(data.countryCode),
              })
            }}
            onBlur={checkHasBenefits}
          />
        </div>
        {!memberMobx.isLogin && contactInfo.countryCode && contactInfo.contactMobile && hasBenefits && (
          hasBenefitsContentReander()
        )}
        <div
          className='checkout-contact-error show'
          style={{ display: contactError.mobileError ? 'block' : 'none' }}
        >
          <span>{i18n.t('checkout.plInputRightMobile')}</span>
        </div>
        {window.bo !== 'cn' && !memberMobx.isLogin ? _tipRender() : null}
      </div>
    </div>
  )

  return (
    <div className='mall-checkout-contact-wrapper'>
      {
        contactInfo.countryCode && contactInfo.contactMobile ? (hasBenefits ? (!memberMobx.isLogin && (!(expand || notFill)) && (
          hasBenefitsContentReander()
        )) : <LoginGuide isLogin={memberMobx.isLogin} />) : (
          <LoginGuide isLogin={memberMobx.isLogin} />
        )
      }
      {(expand || notFill) ? _expandRender() : _unExpandRender()}
    </div>
  )
}

export default observer(CheckoutContact)
